import { render, staticRenderFns } from "./using-the-isbar-framework.vue?vue&type=template&id=3c052883&scoped=true&"
import script from "./using-the-isbar-framework.vue?vue&type=script&lang=js&"
export * from "./using-the-isbar-framework.vue?vue&type=script&lang=js&"
import style0 from "./using-the-isbar-framework.vue?vue&type=style&index=0&id=3c052883&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c052883",
  null
  
)

export default component.exports